<template>
  <div class="carousel" :style="{...wrapStyle}"
       @click="handleClickEvent()"
       @mouseenter="handleEvent('hover')"
  >
    <div style="overflow: hidden;width: 100%;height: 100%;" v-show="!isMarquee">
      <div
        class="carousel-panel" ref="container" :style="carouselPanelStyle">
        <div v-if="!images.length">
          <div class="carousel-panel__image" :class="getCss('default')"/>
        </div>
        <template v-else>
          <div
            v-for="(image, index) in images"
            :key="index"
            :ref="'carousel-' + index"
            class="carousel-panel__image"
            :class="[isVertical ? 'carousel-panel__vertical' : 'carousel-panel__horizontal']"
            @click="clickHandler(image)"
          >
            <img
              v-if="image.src"
              :class="getCss(['cover','show-img'])"
              v-src="image.src"
              width="100%"
              height="100%"
              :alt="image.alt"
            />
            <div v-else class="carousel-panel__image" :class="getCss('default')"/>
          </div>
        </template>
      </div>
    </div>

    <!-- 左右按钮 -->
    <div
      :style="`--arrow-opacity: ${arrowOpacity};--arrow-bg-color: ${arrowBgColor};
      --arrow-width:${arrowWidth}; --arrow-height:${arrowHeight}`"
      v-show="hasArrowButton && !isMarquee"
    >
      <a
        href="javascript:;"
        :style="{...leftStyle,'--leftArrow':leftArrow}"
        ref="leftArrowButton"
        :class="{
        [getCss('left')]:true,
        'carousel-arrow':true,
        [getCss('left-default-arrow')]:!this.styles.carousel.config.leftArrowImage,
        }"
      >
        <i></i>
      </a>

      <a
        href="javascript:;"
        ref="rightArrowButton"
        :style="{...rightStyle,'--rightArrow':rightArrow}"
        :class="{
          [getCss('right')] : true,
          'carousel-arrow':true,
          [getCss('right-default-arrow')]:!this.styles.carousel.config.rightArrowImage,
        }"
      >
        <i></i>
      </a>
    </div>
    <!-- 分页器 -->
    <ul
      v-show="styles.carousel.config.hasIndicatePoint && !isMarquee"
      class="carousel-pagination"
      ref="carouselPaginationDots"
      :class="[isVertical ? 'carousel-pagination__vertical' : 'carousel-pagination__horizontal']"
      :style="indicatorPointStyle"
    >
      <li
        v-for="index in styles.carousel.images.length"
        :key="index"
        class="carousel-pagination__item"
        :style="itemStyle"
        :class="['carousel-pagination__item',
          getIndexDotClass(index),
       index -1 === currentIndex ? 'carousel-pagination__item--active' : '' ]"
      />
    </ul>
    <!--容器-->
    <div class="c-carousel__content" v-if="!isMarquee" >
      <div class="c-carousel__content_outer" ref="containerContent">
        <template v-for=" (item, index) in pureImages">
          <div
            :key="index"
            class="c-carousel__content-slot"
            :style="`--slot-display: ${isVertical ? 'block' : 'inline-block'};`"
            >
            <div class="c-carousel__content-slot-position">
              <slot :name="`${index}`"></slot>
            </div>
          </div>
        </template>
      </div>
    </div>
    <ul id="mylspaomadeng" v-show="isMarquee" :class="getCss('ul-marquee')" ref="divMerquee">
      <li v-for="(item,index) in images" :key="index" :class="getCss('iconShow')">
        <img :style="{...imgStyle}" :src="item.src"/>
      </li>
    </ul>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';

export default {
  name: 'CCarousel',
  mixins: [componentBaseMixin],
  props: {
    events: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cssPrefix: 'carousel-',
      classKeys: ['default', 'cover', 'fill'],
      arrowOpacity: 1,
      currentIndex: 0,
      needBackGround: true,
      timer: null, // 自动轮播的定时器
      touchRuntimeData: {
        startX: 0, // 定义X轴手指位置
        startY: 0,  // 定义Y轴手指位置
        moveY: 0,  // 定义Y轴移动距离
        moveX: 0,  // 定义X轴移动距离
        flag: false,  // 判断是否滑动了
      }, // 滑动数据
      scrollStep: 0, // 滑动步长
    };
  },

  computed: {
    hasArrowButton() {
      return this.styles.carousel.config.hasArrowButton;
    },
    arrowBgColor() {
      return this.styles.carousel.config.leftArrowImage ? 'none' : 'rgba(31,45,61,0.2)';
    },
    leftArrow() {
      return `url('${this.styles.carousel.config.leftArrowImage || 'none'}')`;
    },
    rightArrow() {
      return `url('${this.styles.carousel.config.rightArrowImage || 'none'}')`;
    },
    arrowWidth() {
      return this.deviceMode === 'pc' && !this.$isInEditor ? '64px' : '0.64rem';
    },
    arrowHeight() {
      return this.deviceMode === 'pc' && !this.$isInEditor ? '64px' : '0.64rem';
    },
    defaultColor() {
      return this.styles.carousel.config.defaultColor || '#BAC5D9';
    },
    activeColor() {
      return this.styles.carousel.config.activeColor || '#E4EAF4';
    },
    indicatorPointStyle() {
      const { indicationPointPositionType = 1, indicationPointBorderRadius = '25px' } = this.styles.carousel.config;
      const px = parseInt(indicationPointBorderRadius.substring(0, indicationPointBorderRadius.length - 2), 10);
      const rem = parseFloat(px / 100, 3);
      console.log('indicationPointPositionType px = rem =', px, rem);
      let bottom = 0;
      if (this.deviceMode === 'pc' && !this.isInEditor) {
        // margin 加了 5px
        bottom = indicationPointPositionType === 1 ? '5px' : `-${px + 10}px`;
      } else {
        bottom = indicationPointPositionType === 1 ? '0.1rem' : `-${0.2 + rem}rem`;
      }
      return {
        '--default-color': this.defaultColor,
        '--active-color': this.activeColor,
        position: 'absolute',
        bottom,
        display: 'block',
      };
    },
    isVertical() {
      // 是否纵向
      return this.styles.carousel.config.direction === 'vertical';
    },
    isMarquee() {
      return this.styles.carousel.config.isMarquee || false;
    },
    leftStyle() {
      // transformOrigin 设置选择的定点
      return this.isVertical
        ? {
          left: '50%',
          top: '0',
          transform: 'translateX(-50%) rotate(90deg)',
          transformOrigin: 'center',
        }
        : { top: '50%', transform: 'translateY(-50%)', left: '0.07rem' };
    },
    rightStyle() {
      return this.isVertical
        ? {
          left: '50%',
          bottom: '0',
          transform: 'translateX(-50%) rotate(90deg)',
          transformOrigin: 'center',
        }
        : { top: '50%', transform: 'translateY(-50%)', right: '0.07rem' };
    },
    imgStyle() {
      return {
        width: this.deviceMode === 'pc' ? `${parseInt(this.styles.carousel.config.width, 10) || 200}px` : `${parseInt(this.styles.carousel.config.width, 10) / 100 || 2}rem`,
        height: '100%',
      };
    },
    wrapStyle() {
      if (this.needBackGround) {
        return {
          ...this.styles.base,
          backgroundColor: '#a7badb',
          overflow: this.isMarquee ? 'hidden' : 'visible',
        };
      }
      return {
        ...this.styles.base,
        overflow: this.isMarquee ? 'hidden' : 'visible',
      };
    },
    itemStyle() {
      //  分页点的样式
      const { indicationPointBorderRadius = '' } = this.styles.carousel.config;
      console.log('indicationPointBorderRadius =', indicationPointBorderRadius);
      let size = {};
      if (this.deviceMode === 'pc' && !this.$isInEditor) {
        size = { width: indicationPointBorderRadius || '25px', height: indicationPointBorderRadius || '25px' };
      } else {
        let remUint = 0.25;
        if (indicationPointBorderRadius) {
          remUint = parseInt(
            indicationPointBorderRadius.substring(0, indicationPointBorderRadius.length - 2),
            10,
          ) / 100;
        }
        remUint = `${remUint > 0 ? remUint : 0.25}rem`;
        size = { width: remUint || '0.25rem', height: remUint || '0.25rem' };
      }
      return this.isVertical ? { display: 'block', ...size } : { display: 'inline-block', ...size };
    },
    images() {
      try {
        const { images } = this.styles.carousel;
        console.log('images =', images);
        if (Array.isArray(images) && images.length > 0) {
          return  [images[images.length - 1], ...images, images[0]];
        }
        return  [];
      } catch (e) {
        console.error('set  carousel img error msg', e);
        return  [];
      }
    },
    pureImages() {
      try {
        const { images } = this.styles.carousel;
        console.log('pureImage images =', images);
        if (Array.isArray(images) && images.length > 0) {
          return  images;
        }
        return  [];
      } catch (e) {
        console.error('set  carousel img error msg', e);
        return  [];
      }
    },
    eventMap() {
      const result = {};
      this.events.forEach((item) => {
        // 打开链接
        if (item.action === 'redirectURL' && item.trigger === 'click') {
          if (item.data && item.data[0]) {
            result[item.data[0].index] = item.data[1] || {};
          }
        }
      });
      return result;
    },
    // 自动播放
    isAutoPLay() {
      return !!this.styles?.carousel?.config?.autoPlay;
    },
    autoplaySpeed() {
      return   this.styles?.carousel?.config?.autoplaySpeed || 1500;
    },
    // 实际上轮播的节点  -2: 为了实现无缝链接，重复了两个头尾节点
    total() {
      return   this.images.length - 2; //  真实节点
    },

    // 为了实现 从第2个节点开始轮播
    carouselPanelStyle() {
      if (this.isVertical) {
        return {
          marginTop: `-${this.styles.base.height}`,
        };
      }
      return { marginLeft: '-100%' };
    },
    translateText() {
      if (this.isVertical) {
        return  'translateY';
      }
      return 'translateX';
    },
  },
  watch: {
    curSlot: {
      deep: true,
      handler(curSlot) {
        this.currentIndex = parseInt(curSlot[this.uid], 10) || 0;
        this.moveTo(this.currentIndex);
      },
    },
  },
  beforeDestroy() {
    this.removeScreenScrollAndTouch();
  },
  mounted() {
    console.log('this.styles carousel config =', this.styles);
    if (this.images.length > 0) {
      this.needBackGround = false;
    }
    // 文字走马灯
    if (this.isMarquee) {
      return  this.startTimer();
    }
    // 图片轮播
    // this.setAutoplay(this.styles.carousel.config.autoplaySpeed || 1500);
    this.$nextTick(() => {
      this.initScreenScrollAndTouch();
      Object.keys(this.$refs).forEach((key) => {
        if (key.startsWith('carousel-')) {
          this.reportExposeRaw
            && this.reportExposeRaw({
              ele: this.$refs[key][0],
              ceibaComponentId: `${this.id}`,
              ceibaComponentUid: this.uid,
              eventId: 1030,
              ext: JSON.stringify({
                sub_type: 'expose-carousel',
                data: {
                  carousel_index: key.split('-')[1],
                },
              }),
            });
        }
      });
    });
    this.listenArrowEvent();
  },
  methods: {
    clickHandler(item) {
      const data = this.eventMap[item.index];
      if (data && data.link === 'current') {
        // 上报轮播点击
        this.reportCustomEvent({
          ceibaComponentId: `${this.id}`,
          ceibaComponentUid: this.uid,
          eventId: 1031,
          ext: JSON.stringify({
            sub_type: 'pick-carousel',
            data: {
              carousel_index: item.index,
            },
          }),
        });
        const pageData = {
          action: 'redirectURL',
          data: [data],
          id: item.index,
          name: '单击时',
          trigger: 'click',
          type: 'text',
        };
        this.$emit('defined-event-emitted', [pageData]);
      } else if (data && data.link === 'outer') {
        let url = data.page;
        // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
        url = common.tool.passThroughUrlParam(url, ['via', 'trace_id', 'via_source']);
        if (data.target === '_self') {
          window.location.href = url;
        } else {
          window.open(url);
        }
      }
    },
    listenArrowEvent() {
      if (this.$isInEditor) return;
      if (this.deviceMode === 'pc') {
        // 冒泡事件类型触发
        this.$nextTick(() => {
          const { container } = this.$refs;
          container.addEventListener('mouseover', this.mouseoverFunc, true);
          // 冒泡事件类型触发;
          container.addEventListener('mouseout', this.mouseleaveFunc, true);
        });
      }
    },
    mouseoverFunc() {
      this.arrowOpacity = 1;
    },
    mouseleaveFunc() {
      this.arrowOpacity = 0;
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = null;
    },
    // 文字 走马灯
    startTimer() {
      if (this.mylsTimer !== null) {
        clearInterval(this.mylsTimer);
      }
      const oUl = this.$refs.divMerquee;
      // console.log('oUl', oUl);
      if (oUl !== null) {
        let i;
        oUl.innerHTML += oUl.innerHTML;
        oUl.innerHTML += oUl.innerHTML;
        oUl.innerHTML += oUl.innerHTML;
        const lis = oUl.getElementsByTagName('li');
        // console.log('lis', lis);
        let lisTotalWidth = 0;
        let resetWidth = 0;
        for (i = 0; i < lis.length; i++) {
          lisTotalWidth += lis[i].offsetWidth;
        }
        for (i = 1; i <= lis.length / 4; i++) {
          resetWidth += lis[i].offsetWidth;
        }
        console.log('this.deviceMode.offsetWidth', lisTotalWidth, resetWidth);
        oUl.style.width = this.deviceMode === 'pc' ? `${lisTotalWidth}px` : `${lisTotalWidth * 16}px`;
        resetWidth = this.deviceMode === 'pc' ? resetWidth : resetWidth * 10;
        console.log('this.deviceMode.offsetWidth', lisTotalWidth, resetWidth);
        let left = 0;
        this.mylsTimer = setInterval(() => {
          left -= 1;
          if (left <= -resetWidth) {
            left = 0;
          }
          oUl.style.left = `${left}px`;
        }, this.styles.carousel.config.timeout || 20);
      }
    },
    moveTransition(obj, distance) {
      // eslint-disable-next-line no-param-reassign
      obj.style.transition = 'transform 300ms ease';  // 添加过渡效果，0.3s完成图片滚动
      // eslint-disable-next-line no-param-reassign
      obj.style.transform = `${this.translateText}(${distance}px)`;
    },
    moveNoTransition(obj, distance)  {
      // eslint-disable-next-line no-param-reassign
      obj.style.transition = 'none';  // 去掉过渡效果，让container快速跳到目标位置
      // eslint-disable-next-line no-param-reassign
      obj.style.transform = `${this.translateText}(${distance}px)`;
    },
    /**
     *  获取轮播的每次的步长，取消放在计算属性为了解决轮播放在容器内 因为是隐藏，无法获取隐藏元素的offsetWidth
     * @returns {number}
     */
    getScrollStep() {
      const  { container } = this.$refs;
      this.scrollStep =   !this.isVertical ? container.parentNode?.offsetWidth  : container.parentNode?.offsetHeight;
      return this.scrollStep;
    },
    transitionendEvent() {
      if (this.currentIndex > this.total - 1) {
        this.currentIndex = 0;
      } else if (this.currentIndex < 0) {
        this.currentIndex = this.total - 1 ;
      }
      this.moveNoTransition(this.$refs.container, -this.currentIndex * this.getScrollStep());
      this.moveNoTransition(this.$refs.containerContent, -this.currentIndex * this.getScrollStep());
    },
    moveNext(e) {
      e.stopPropagation();
      console.log('click moveNext right this.distance=');
      this.moveTo(1 +  this.currentIndex);
      // 停止定时器
      this.clearTimer();
      // 重置定时
      this.initAutoPlay();
    },
    movePrevious(e) {
      e.stopPropagation();
      console.log('click movePrevious previous this.distance=');
      this.moveTo(-1 +  this.currentIndex);
      // 停止定时器
      this.clearTimer();
      // 重置定时
      this.initAutoPlay();
    },
    moveTo(index) {
      this.currentIndex =  index;
      this.moveTransition(this.$refs.container, -this.currentIndex * this.getScrollStep());
      this.moveTransition(this.$refs.containerContent, -this.currentIndex * this.getScrollStep());
    },
    getIndexDotClass(index) {
      return `carousel_pagination_item_index_${index}`;
    },
    // 指示点触发轮播
    moveToTouchByDotNodes(e) {
      const className =  e.target.className.split(' ').find(c => c.startsWith('carousel_pagination_item_index_'));
      console.log('moveIndex className', className);
      if (className) {
        let moveIndex =  className.substring(className.lastIndexOf('_') + 1);
        moveIndex =  parseInt(moveIndex, 10) || 0;
        moveIndex = moveIndex - 1;
        console.log('moveIndex', moveIndex);
        if (moveIndex >= 0) {
          this.moveTo(moveIndex);
        }
      }
      // 停止定时器
      this.clearTimer();
      // 重置定时
      this.initAutoPlay();
    },
    touchStart(e) {
      console.log('touchstart ', e);
      e.stopPropagation();
      this.touchRuntimeData.startX = e.targetTouches[0].pageX;
      this.touchRuntimeData.startY = e.targetTouches[0].pageY;
      // 停止定时器
      this.clearTimer();
    },
    touchMove(e) {
      this.touchRuntimeData.moveX = e.targetTouches[0].pageX -  this.touchRuntimeData.startX;
      this.touchRuntimeData.moveY = e.targetTouches[0].pageY - this.touchRuntimeData.startY;
      // 移动盒子：盒子原来的距离 + 移动的距离
      const translateX = -this.currentIndex *  this.getScrollStep() + this.touchRuntimeData.moveX;
      this.moveNoTransition(this.$refs.container, translateX);
      this.moveNoTransition(this.$refs.containerContent, translateX);
      if (Math.abs(this.touchRuntimeData.moveX) > Math.abs(this.touchRuntimeData.moveY)) {
        e.preventDefault();  // 阻止默认事件
      }
      this.touchRuntimeData.flag = true;
    },
    touchEnd() {
      if (this.touchRuntimeData.flag) {
        // 判断如果移动距离大于50px那么就移动到下一张或上一张  横向
        if (!this.isVertical && Math.abs(this.touchRuntimeData.moveX) > 50) {
          // 如果是右滑就表示滑动到上一张，moveX>0
          if (this.touchRuntimeData.moveX > 0) {
            this.currentIndex = this.currentIndex  - 1;
          } else {
            // 如果是左滑就表示滑动到下一张，moveX<0
            this.currentIndex = this.currentIndex  + 1;
          }
          this.moveTransition(this.$refs.container, - this.currentIndex * this.getScrollStep());

          this.moveTransition(this.$refs.containerContent, - this.currentIndex * this.getScrollStep());
        }

        // 判断如果移动距离大于50px那么就移动到下一张或上一张  纵向
        if (this.isVertical && Math.abs(this.touchRuntimeData.moveY) > 50) {
          // 如果是右滑就表示滑动到上一张，moveX>0
          if (this.touchRuntimeData.moveY > 0) {
            this.currentIndex = this.currentIndex  - 1;
          } else {
            // 如果是左滑就表示滑动到下一张，moveX<0
            this.currentIndex = this.currentIndex  + 1;
          }
          this.moveTransition(this.$refs.container, - this.currentIndex * this.getScrollStep());
          this.moveTransition(this.$refs.containerContent, - this.currentIndex * this.getScrollStep());
        }
      }
      // 停止定时器
      this.clearTimer();
      // 重置定时
      this.initAutoPlay();
      this.touchRuntimeData.flag = false;
    },
    initAutoPlay() {
      if  (!this.isAutoPLay) return;
      const  { container, containerContent } = this.$refs;
      const that = this;
      this.timer = setInterval(() => {
        // 获取不了步长是因为轮播在容器内被隐藏 currentIndex不进行计数
        if (that.getScrollStep() === 0)  {
          return;
        };
        // eslint-disable-next-line no-plusplus
        that.currentIndex++;
        that.moveTransition(container,  -that.currentIndex * this.getScrollStep());
        that.moveTransition(containerContent,  -that.currentIndex * this.getScrollStep());
      }, this.autoplaySpeed);
    },

    removeScreenScrollAndTouch() {
      if (this.$isInEditor) return;
      if (this.total  <= 1) {
        return;
      }
      const {  container, containerContent,
        rightArrowButton, leftArrowButton, carouselPaginationDots } = this.$refs;
      // rightArrowButton
      if (rightArrowButton) {
        rightArrowButton.removeEventListener('click', this.moveNext);
      }
      if (leftArrowButton) {
        leftArrowButton.removeEventListener('click', this.movePrevious);
      }
      if (carouselPaginationDots) {
        [].slice.call(carouselPaginationDots).forEach((li) => {
          li.removeEventListener('click', this.moveToTouchByDotNodes);
        });
      }
      // 2. 监听过渡完成事件transitionend
      container.removeEventListener('transitionend', this.transitionendEvent);
      if (this.isVertical) {
        return;
      }
      // 4. 手指移动轮播图
      containerContent.removeEventListener('touchstart', this.touchStart);
      // 移动元素touchmove 获取移动距离
      containerContent.removeEventListener('touchmove', this.touchMove);
      // 手指离开touchend，根据手指移动的距离来判断是否移动到上一张或者下一张
      containerContent.removeEventListener('touchend', this.touchEnd);
      // 去除监听事件
      this.clearTimer();
    },
    initScreenScrollAndTouch() {
      if (this.$isInEditor) return;
      //  只有一个真实节点
      if (this.total  <= 1) {
        return;
      }
      // carouselPaginationDots 指示点
      // rightArrowButton 右箭头
      // leftArrowButton 左箭头
      // container 监听轮播图片容器
      // containerContent 用于监听手指滑动区域
      const {  container, containerContent,
        rightArrowButton, leftArrowButton, carouselPaginationDots } = this.$refs;
      // 自动轮播
      if (this.isAutoPLay) {
        this.initAutoPlay();
      }
      // rightArrowButton
      if (rightArrowButton) {
        rightArrowButton.addEventListener('click', this.moveNext);
      }
      if (leftArrowButton) {
        leftArrowButton.addEventListener('click', this.movePrevious);
      }
      if (carouselPaginationDots) {
        carouselPaginationDots.addEventListener('click', this.moveToTouchByDotNodes);
      }
      // 2. 监听过渡完成事件transitionend
      container.addEventListener('transitionend', this.transitionendEvent);
      // 纵向滚动不添加手指滑动，效果不好，与body页面滚动有重叠
      if (this.isVertical) {
        return;
      }
      // 4. 手指移动轮播图
      containerContent.addEventListener('touchstart', this.touchStart);
      // 移动元素touchmove 获取移动距离
      containerContent.addEventListener('touchmove', this.touchMove);
      // 手指离开touchend，根据手指移动的距离来判断是否移动到上一张或者下一张
      containerContent.addEventListener('touchend', this.touchEnd);
    },
  },
};
</script>
<style lang="scss" scoped>
.c-carousel__content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.c-carousel__content_outer {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

.c-carousel__content-slot {
  //position: absolute;
  width: 100%;
  height: 100%;
  display: var(--slot-display);
  // display: inline-block;
}

.c-carousel__content-slot-position {
  position: absolute;
  width: 100%;
  height: 100%;
}

.carousel {
  &-panel {
    // 默认显示第二张图片,将第二张图片

    width: 100%;
    height: 100%;
    white-space: nowrap;

    &__image {
      width: 100%;
      height: 100%;
    }

    &__vertical {
      display: block;
    }

    &__horizontal {
      display: inline-block;
    }
  }

  &-arrow {
    opacity: var(--arrow-opacity);
    position: absolute;
    width: var(--arrow-height);
    height: var(--arrow-height);
    z-index: 999;
    display: inline-block;
    //background-color: rgba(31,45,61,0.2);
    background-color: var(--arrow-bg-color);
    transition: all 0.4s;
    outline: none;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }

  &-pagination {
    position: absolute;
    z-index: 999;
    font-size: 0;
    border-radius: 0.125rem;

    &__vertical {
      right: 0.1rem;
      top: 50%;
      transform: translateY(-50%);
      justify-content: center;
      flex-direction: row;
      display: flex;
    }

    &__horizontal {
      left: 50%;
      bottom: 0.1rem;
      transform: translateX(-50%);
      justify-content: center;
      flex-direction: row;
      display: flex;
    }

    &__item {
      margin: 5px;
      width: 0.25rem;
      height: 0.25rem;
      border-radius: 50%;
      background: var(--default-color);
      cursor: pointer;

      &--active {
        background: var(--active-color);
      }
    }
  }
}
</style>
<style lang="scss">
@import './carousel.scss';
</style>
